module.exports = __webpack_public_path__ + "media/images/emblems/Egolzwil_LU-8578b2a62565cc17a66514d26f04f7bc.png";